/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RescueFirmwareResponse,
    RescueFirmwareResponseFromJSON,
    RescueFirmwareResponseFromJSONTyped,
    RescueFirmwareResponseToJSON,
} from './RescueFirmwareResponse';

/**
 * 
 * @export
 * @interface RescueResponse
 */
export interface RescueResponse {
    /**
     * 
     * @type {string}
     * @memberof RescueResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof RescueResponse
     */
    deviceTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof RescueResponse
     */
    deviceType?: string;
    /**
     * 
     * @type {string}
     * @memberof RescueResponse
     */
    hwId?: string;
    /**
     * 
     * @type {string}
     * @memberof RescueResponse
     */
    usId?: string;
    /**
     * 
     * @type {string}
     * @memberof RescueResponse
     */
    description?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RescueResponse
     */
    loaderAvailableVersions?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RescueResponse
     */
    fwAvailableVersions?: { [key: string]: string; };
    /**
     * 
     * @type {RescueFirmwareResponse}
     * @memberof RescueResponse
     */
    currentRescueFirmware?: RescueFirmwareResponse;
    /**
     * 
     * @type {RescueFirmwareResponse}
     * @memberof RescueResponse
     */
    lastRescueFirmware?: RescueFirmwareResponse;
    /**
     * 
     * @type {string}
     * @memberof RescueResponse
     */
    finalUrl?: string;
}

export function RescueResponseFromJSON(json: any): RescueResponse {
    return RescueResponseFromJSONTyped(json, false);
}

export function RescueResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RescueResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deviceTypeId': !exists(json, 'deviceTypeId') ? undefined : json['deviceTypeId'],
        'deviceType': !exists(json, 'deviceType') ? undefined : json['deviceType'],
        'hwId': !exists(json, 'hwId') ? undefined : json['hwId'],
        'usId': !exists(json, 'usId') ? undefined : json['usId'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'loaderAvailableVersions': !exists(json, 'loaderAvailableVersions') ? undefined : json['loaderAvailableVersions'],
        'fwAvailableVersions': !exists(json, 'fwAvailableVersions') ? undefined : json['fwAvailableVersions'],
        'currentRescueFirmware': !exists(json, 'currentRescueFirmware') ? undefined : RescueFirmwareResponseFromJSON(json['currentRescueFirmware']),
        'lastRescueFirmware': !exists(json, 'lastRescueFirmware') ? undefined : RescueFirmwareResponseFromJSON(json['lastRescueFirmware']),
        'finalUrl': !exists(json, 'finalUrl') ? undefined : json['finalUrl'],
    };
}

export function RescueResponseToJSON(value?: RescueResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'deviceTypeId': value.deviceTypeId,
        'deviceType': value.deviceType,
        'hwId': value.hwId,
        'usId': value.usId,
        'description': value.description,
        'loaderAvailableVersions': value.loaderAvailableVersions,
        'fwAvailableVersions': value.fwAvailableVersions,
        'currentRescueFirmware': RescueFirmwareResponseToJSON(value.currentRescueFirmware),
        'lastRescueFirmware': RescueFirmwareResponseToJSON(value.lastRescueFirmware),
        'finalUrl': value.finalUrl,
    };
}

